// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'flag-icon-css/css/flag-icons.css';
import routes from './router'
import store from './store/store'
import axios from './config/httpConfig'
// import axios from 'axios'
import VueRouter from 'vue-router'
// import $ from 'jquery'
const echarts = require('echarts');
// import echarts from 'echarts'
import $ from 'jquery'
import validater from '../src/common/js/formvalidate.js'
import cusDialog from "@/components/dialog/dialogMsg";
import cusUpload from "@/components/Upload/upLoadFile";
import common from '../src/common/js/common.js';
import util from '../src/common/js/util.js';
import {
	Message
} from 'element-ui';

ElementUI.Dialog.props.lockScroll.default = false
Vue.config.productionTip = false
import Global from '../src/common/js/Global.js';
Vue.prototype.Global = Global;
Vue.prototype.Glod = Glod;

Vue.prototype.$axios = axios;
Vue.prototype.$message = Message;
Vue.prototype.$echarts = echarts

Vue.component("cus-dialog", cusDialog)
Vue.component("cus-upload", cusUpload)
Vue.use(VueRouter)
Vue.use(ElementUI);
Vue.prototype.$ = $;
Vue.prototype.$com = common;
Vue.prototype.$util = util;
Vue.prototype.$validater = validater;
Vue.prototype.$state = store.state;

import htmlToPdf from "@/common/js/htmlToPdf.js"
Vue.use(htmlToPdf)
Vue.prototype.$tableHeight = window.innerHeight - 250;


// 适配
import 'px2rem-loader';
import 'postcss-px2rem';
import './config/rem.js';
import './assets/style.scss';
//是否是移动端
Vue.prototype.$isMobile=function(){
 	let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    
	return flag!=null;
};
const router = new VueRouter({
	mode: 'history',
	routes: routes
})
//重写localStorage缓存
let getItem = localStorage.getItem.bind(localStorage)
let setItem = localStorage.setItem.bind(localStorage)
let removeItem = localStorage.removeItem.bind(localStorage)
localStorage.getItem = function(keyName) {
	let val = getItem(keyName);
	if (!val || val == null) {
		return null;
	}
	val = JSON.parse(val);

	if (val.expire) {
		if (Date.now() - val.time > val.expire) {
			removeItem(keyName);
			return null;
		}
	}
	return val.data;
}
localStorage.setItem = function(keyName, keyValue, expires) {
	let obj = {
		data: keyValue,
		time: Date.now(),
		expire: expires
	};

	return setItem(keyName, JSON.stringify(obj))
}

/**
 * author: zuokun
 * 水印
 * text：水印文字
 * font：字体
 * textColor：文字颜色
 * width：宽度
 * height：高度
 * textRotate：偏转度 -90到0， 负数值，不包含-90
 */
Vue.directive('watermark', (el, binding) => {
	let text = binding.value.text;
	let font = binding.value.font || "22px Microsoft JhengHei";
	let textColor = binding.value.textColor || "rgba(215, 215, 215, 0.2)";
	let width = binding.value.width || 400;
	let height = binding.value.height || 200;
	let textRotate = binding.value.textRotate || -20;

	function addWaterMarker(parentNode) {
		var can = document.createElement('canvas');
		parentNode.appendChild(can);
		can.width = width;
		can.height = height;
		can.style.display = 'none';
		var cans = can.getContext('2d');
		cans.rotate(textRotate * Math.PI / 180);
		// cans.rotate(Math.PI / 6)
		cans.font = font;
		cans.fillStyle = textColor;
		cans.textAlign = 'left';
		cans.textBaseline = 'Middle';
		cans.fillText(text, 0, can.height);
		parentNode.style.backgroundImage = "url(" + can.toDataURL("image/png") + ")";
	}
	addWaterMarker(el)
})


//路由守卫
router.beforeEach((to, from, next) => {
  // 在路由跳转前记录日志
  axios.post('Sysbrowsinglog/SysbrowsinglogEdit', {
    fPagePath: Glod.WebSite+to.fullPath, // 当前路由的完整路径
    //referrer: from.fullPath // 上一个路由的完整路径
  }).then(res => {
    console.log(res);
  }).catch(error => {
    console.error('写入访问日志异常:', error);
  });


	if (to.path == '/login') {
		localStorage.clear();
		next();
	} else {
		let token = localStorage.getItem('token');
		if (to.path.search("system") >= 0 || to.path.search("patent") >= 0) {
			if (token === undefined || token === '' || token == null) {
				next('/login');
				// Message.warning("您需要登录才能继续操作");
			} else {
				//初始化token过期时间
				localStorage.setItem('token', token, 60000000);
				next()
			}
		} else {
			if (token != null) {
				//初始化token过期时间
				localStorage.setItem('token', token, 60000000);
			}
			next();
		}
		// if (token === undefined || token === '' || token == null) {
		// 	next('/login');
		// 	// Message.warning("您需要登录才能继续操作");
		// } else {
		// 	//初始化token过期时间
		// 	localStorage.setItem('token', token, 60000000);
		// 	next()
		// }
	}

})



new Vue({
	el: '#app',
	router,
	store,
	components: {
		App
	},
	template: '<App/>',
	beforeCreate() {
		Vue.prototype.$bus = this
	}
})



// WEBPACK FOOTER //
// ./src/main.js